<div class="main-container">
  <p-toast></p-toast>
  <div class="left-container">
    <table class="contact-table">
      <colgroup>
        <col class="left-table-first-col">
        <col class="left-table-second-col">
      </colgroup>
      <tr class="contact-list-item">
        <td>
          <strong>
            First name
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.firstName}}
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Family name
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.lastName}}
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Language
          </strong>
        </td>
        <td>
          <p *ngIf="contactRequestService.contactRequest!.language">
            {{contactRequestService.contactRequest!.language.name}}
          </p>
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Country
          </strong>
        </td>
        <td>
          <p *ngIf="contactRequestService.contactRequest!.country">
            {{contactRequestService.contactRequest!.country.name}}
          </p>
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            City - Country
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.cityCountry}}
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Phone number
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.phoneNumber}}
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Email
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.email}}
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Destination
          </strong>
        </td>
        <td>
          <p *ngIf="contactRequestService.contactRequest!.destination">
            {{contactRequestService.contactRequest!.destination.name}}
          </p>
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Programme
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.interestedIn}}
        </td>
      </tr>
      <tr class="contact-list-item" *ngIf="contactRequestService.contactRequest!.accommodationType">
        <td>
          <strong>
            Accommodation
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.accommodationType.name}}
        </td>
      </tr>
      <tr>
        <td>

        </td>
        <td>
          {{contactRequestService.contactRequest!.otherAccommodationType}}
        </td>
      </tr>
      <tr class="contact-list-item" *ngIf="contactRequestService.contactRequest!.roomType">
        <td>
          <strong>
            Room
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.roomType.name}}
        </td>
      </tr>
      <tr>
        <td>

        </td>
        <td>
          {{contactRequestService.contactRequest!.otherRoomType}}
        </td>
      </tr>
      <tr class="contact-list-item" *ngIf="contactRequestService.contactRequest!.boardType">
        <td>
          <strong>
            Board
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.boardType.name}}
        </td>
      </tr>
      <tr>
        <td>

        </td>
        <td>
          {{contactRequestService.contactRequest!.otherBoardType}}
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Travel Insurance
          </strong>
        </td>
        <td>
          <p-checkbox [binary]="true" [readonly]="true" [(ngModel)]="contactRequestService.contactRequest!.needInsurance">
          </p-checkbox>
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Cancellation Insurance
          </strong>
        </td>
        <td>
          <p-checkbox [binary]="true" [readonly]="true"
            [(ngModel)]="contactRequestService.contactRequest!.needGarantieAnnulation"></p-checkbox>
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Birthdate
          </strong>
        </td>
        <td>
          <p *ngIf="contactRequestService.contactRequest!.birthDate">
            {{contactRequestService.contactRequest!.birthDate.toDate() | date: 'dd/MM/yyyy'}}
          </p>
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Course intensity
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.courseType}}
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Course option
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.courseOption}}
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Start date
          </strong>
        </td>
        <td>
          <span *ngIf="contactRequestService.contactRequest!.startDate">
            {{contactRequestService.contactRequest!.startDate.toDate() | date: 'dd/MM/yyyy'}}
          </span>
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            End date
          </strong>
        </td>
        <td>
          <span *ngIf="contactRequestService.contactRequest!.endDate">
            {{contactRequestService.contactRequest!.endDate.toDate() | date: 'dd/MM/yyyy'}}
          </span>
        </td>
      </tr>
      <tr class="contact-list-item">
        <td>
          <strong>
            Duration
          </strong>
        </td>
        <td>
          {{contactRequestService.contactRequest!.duration}}
        </td>
      </tr>
      <tr>
        <td class="contact-message-box-title">
          <strong>
            Message
          </strong>
        </td>
      </tr>
      <tr>
        <td colspan="2" class="contact-message-box">
          <div>
            {{contactRequestService.contactRequest!.message}}
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="right-container">
    <div [formGroup]="leadQuotationService.quotationForm" class="booking-form"
      *ngIf="leadQuotationService.quotationForm">
      <div class="description-box">
        <h3 class="global-title">
          Quotation title
        </h3>
        <input pInputText formControlName="description">
      </div>
      <div class="comment-box">
        <h3 class="global-title">
          Remarks
        </h3>
        <ckeditor [editor]="Editor" formControlName="comment"></ckeditor>
      </div>
      <div class="quotation-options-container">
        <div>
          <p class="global-title">
            Base currency
          </p>
          <p-dropdown dataKey="id" [options]="currencies" optionLabel="isoCode" formControlName="baseCurrency"
            (onChange)="baseCurrencyUpdate()">
          </p-dropdown>
        </div>
        <div>
          <p class="global-title">
            Second currency
          </p>
          <p-dropdown dataKey="id" placeholder="--" [options]="currencies" optionLabel="isoCode"
            (onChange)="secondCurrencyUpdate()" formControlName="secondCurrency" [showClear]="true">
          </p-dropdown>
        </div>
        <div>
          <p class="global-title">
            Quotation date
          </p>
          <p-calendar [monthNavigator]="true" [yearRange]="yearRange" [yearNavigator]="true" formControlName="quotationDate"
            dateFormat="dd/mm/yy"></p-calendar>
        </div>
        <div>
          <p class="global-title">
            Balance due date
          </p>
          <p-calendar [monthNavigator]="true" [yearRange]="yearRange" [yearNavigator]="true" formControlName="dueDate"
            dateFormat="dd/mm/yy"></p-calendar>
        </div>
        <div>
          <p class="global-title">
            Deposit (EUR)
          </p>
          <input pInputText formControlName="deposit">
        </div>
      </div>
      <table class="transaction-table">
        <tr class="first-table-row">
          <th>#</th>
          <th>Type</th>
          <th class="description-th">Remarks</th>
          <th>Price</th>
          <th class="currency-th">Currency</th>
          <!-- Base currency -->
          <th>{{leadQuotationService.quotationForm.get('baseCurrency')!.value.isoCode}}</th>
          <!-- Second currency -->
          <th *ngIf="leadQuotationService.quotationForm.get('secondCurrency')!.value">
            {{leadQuotationService.quotationForm.get('secondCurrency')!.value.isoCode}}</th>
        </tr>
        <tr class="no-record-tr" *ngIf="productFormArray.length==0">
          <td colspan="6">
            <div class="no-record-row">
              <p class="no-record-message">
                No record
              </p>
              <div class="icon-wrap" (click)="insertItem(0)">
                <i class="pi pi-plus"></i>
              </div>
            </div>
          </td>
        </tr>
        <tr formArrayName="products"
          *ngFor="let product of productFormArray; let i = index"
          (mouseenter)="mouseover(i)" (mouseleave)="mouseout(i)">
          <td [formGroupName]="i">
            {{i + 1}}
          </td>
          <td [formGroupName]="i">
            <p-dropdown dataKey="id" [options]="productTypes" formControlName="type" optionLabel="name"
              (onChange)="onProductTypeUpdate($event.value, i)">
              <ng-template pTemplate="item" let-item>
                {{item.name | titlecase}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{item.name | titlecase}}
              </ng-template>
            </p-dropdown>
          </td>
          <td [formGroupName]="i" class="description-container">
            <textarea [rows]="1" pInputTextarea formControlName="description" [autoResize]="true"
              id="description-input"></textarea>
          </td>
          <td [formGroupName]="i">
            <input pInputText formControlName="amount" id="amount-input" (blur)="onAmountBlur(i)">
          </td>
          <td [formGroupName]="i">
            <p-dropdown dataKey="id" [style]="{'minWidth':'50px'}" [options]="currencies" formControlName="currency"
              optionLabel="isoCode" (onChange)="onProductCurrencyUpdate()"
              (keydown.Tab)="pressTabOnCurrencyDropdown(i)"></p-dropdown>
          </td>
          <td>
            {{productPriceInCurrency[i]}}
          </td>
          <td *ngIf="leadQuotationService.quotationForm.get('secondCurrency')!.value">
            {{productPriceInSecondCurrency[i]}}
          </td>
          <td class="menu-head">
            <table class="hover-menu"
              [hidden]="isHidden(i)">
              <tr>
                <td>
                  <div class="icon-container">
                    <i class="pi pi-caret-up" (click)="moveUp(i)"></i>
                  </div>
                </td>
                <td>
                  <div class="icon-container">
                    <i class="pi pi-caret-down" (click)="moveDown(i)"></i>
                  </div>
                </td>
                <td>
                  <div class="icon-container">
                    <i class="pi pi-plus-circle" (click)="insertItem(i)"></i>
                  </div>
                </td>
                <td>
                  <div class="icon-container">
                    <i class="pi pi-times-circle" (click)="removeItem(i)"></i>
                  </div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <div class="price-includes-container">
        <div class="price-includes-editor-container">
          <p class="global-title">
            <b>Prices include</b>
          </p>
          <ckeditor [editor]="Editor" formControlName="priceIncludes"></ckeditor>
        </div>
        <div class="price-includes-editor-container">
          <p class="global-title">
            <b>Prices do not include</b>
          </p>
          <ckeditor [editor]="Editor" formControlName="priceNotIncludes"></ckeditor>
        </div>
        <div>
          <p>
            Total ({{leadQuotationService.quotationForm.get("baseCurrency")!.value.isoCode}}):
            {{totalPriceInBaseCurrency.toFixed(2)}}
          </p>
          <p *ngIf="leadQuotationService.quotationForm.value.secondCurrency && totalPriceInSecondCurrency">
            Total ({{leadQuotationService.quotationForm.get("secondCurrency")!.value.isoCode}}):
            {{totalPriceInSecondCurrency.toFixed(2)}}
          </p>
          <p>
            Cancellation ({{leadQuotationService.quotationForm.get("baseCurrency")!.value.isoCode}}):
            {{totalGarantieAnnulationInBaseCurrency | decimalCeiling}}
          </p>
          <p *ngIf="leadQuotationService.quotationForm.value.secondCurrency && totalGarantieAnnulationInSecondCurrency">
            Cancellation ({{leadQuotationService.quotationForm.get("secondCurrency")!.value.isoCode}}):
            {{totalGarantieAnnulationInSecondCurrency | decimalCeiling}}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog header="Select Template" [(visible)]="displayTemplateDialog" [modal]="true">
  <div class="template-dialog">
    <table>
      <colgroup>
        <col class="template-first-col">
        <col class="template-second-col">
      </colgroup>
      <tr>
        <td>Name</td>
        <td>Last modified</td>
      </tr>
    </table>
    <p-listbox [options]="templates" styleClass="primeng-list-box" optionLabel="name">
      <ng-template let-template let-index="index" pTemplate="item">
        <div [pTooltip]="templateTooltips[index]" tooltipPosition="right" (click)="setFormValuesFromTemplate(template)">
          <table>
            <colgroup>
              <col class="template-first-col">
              <col class="template-second-col">
            </colgroup>
            <tr>
              <td>{{template.name}}</td>
              <td>{{template.lastModified | date: 'dd/MM/yyyy'}}</td>
            </tr>
          </table>
        </div>
      </ng-template>
    </p-listbox>
    <p *ngIf="templates.length==0">Template list is empty.</p>
  </div>
</p-dialog>
<p-dialog header="Save this quotation as template" [(visible)]="displayTemplateCreatingDialog" [modal]="true">
  <div class="template-dialog">
    <p>
      Input the name of template, then save.
    </p>
    <input pInputText [(ngModel)]="selectedTemplateName" class="template-name-input">
    <p-button label="Save" (onClick)="saveQuotationAsTemplate()"></p-button>
  </div>
</p-dialog>